import { render, staticRenderFns } from "./afterCheckCertificate.vue?vue&type=template&id=552eccb8&scoped=true"
import script from "./afterCheckCertificate.vue?vue&type=script&lang=js"
export * from "./afterCheckCertificate.vue?vue&type=script&lang=js"
import style0 from "./afterCheckCertificate.vue?vue&type=style&index=0&id=552eccb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552eccb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552eccb8')) {
      api.createRecord('552eccb8', component.options)
    } else {
      api.reload('552eccb8', component.options)
    }
    module.hot.accept("./afterCheckCertificate.vue?vue&type=template&id=552eccb8&scoped=true", function () {
      api.rerender('552eccb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/afterCheckCertificate.vue"
export default component.exports